import { Component, OnInit } from '@angular/core';
import { LoanPartner, LoanPostStatusResponse, NewLoansService } from '../new-loans.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
    selector: 'brightside-web-loan-info',
    templateUrl: './loan-info.component.html',
    styleUrls: ['./loan-info.component.scss'],
    standalone: false
})
export class LoanInfoComponent implements OnInit {
  loanPartner: LoanPartner;
  loans$: Observable<LoanPostStatusResponse[]> = this.newLoansSvc.loansInfo;
  partnerLink: string;

  loanPartnerInfo = {
    SALARY_FINANCE: {
      img: 'partner-salary-finance.png',
    },
    KASHABLE: {
      img: 'partner-kashable.png',
    },
  };
  img: string;

  constructor(private newLoansSvc: NewLoansService, private router: Router) {
    // this should always be set by now
    this.loanPartner = this.newLoansSvc._cachedCurrentPartnerInfo;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.img = this.loanPartnerInfo[this.loanPartner.type].img;
    this.loans$
      .pipe(
        tap((loans) => {
          const loneLink = loans.filter((loan) => loan.inProgress)[0];
          if (loneLink) {
            this.partnerLink = loneLink.partner.link;
          }
        })
      )
      .subscribe();
  }

  ngOnInit(): void {}

  routeUser() {
    window.open(this.partnerLink, '_blank');
  }

  goHome() {
    this.router.navigate(['home']);
  }
}
